import {
  FaGoogle,
  FaYoutube,
  FaTiktok,
  FaLinkedinIn,
  FaSnapchat,
  FaXTwitter,
  FaInstagram,
} from "react-icons/fa6";

export const APPS = [
  { id: "facebook_instagram", label: "Facebook / Insta", Icon: FaInstagram, brand: "#E1306C" },
  { id: "google", label: "Google", Icon: FaGoogle, brand: "#4285F4" },
  { id: "youtube", label: "YouTube", Icon: FaYoutube, brand: "#FF0000" },
  { id: "tiktok", label: "TikTok", Icon: FaTiktok, brand: "#111827" },
  { id: "linkedin", label: "LinkedIn", Icon: FaLinkedinIn, brand: "#0A66C2" },
  { id: "snapchat", label: "Snapchat", Icon: FaSnapchat, brand: "#D99E00" },
  { id: "x_twitter", label: "X", Icon: FaXTwitter, brand: "#111827" },
];

export const QUESTIONS = [
  {
    key: "age",
    title: "Your age bracket",
    options: [
      { id: "18-24", label: "18–24" },
      { id: "25-34", label: "25–34" },
      { id: "35-44", label: "35–44" },
      { id: "45-54", label: "45–54" },
      { id: "55+", label: "55+" },
    ],
  },
  {
    key: "shopping",
    title: "How often do you shop online?",
    options: [
      { id: "rarely", label: "Rarely" },
      { id: "monthly", label: "Monthly" },
      { id: "weekly", label: "Weekly" },
      { id: "several_weekly", label: "A few times a week" },
    ],
  },
  {
    key: "loyalty",
    title: "Loyalty programs you're in",
    options: [
      { id: "none", label: "None" },
      { id: "1-2", label: "1–2" },
      { id: "3-5", label: "3–5" },
      { id: "6+", label: "6+" },
    ],
  },
  {
    key: "streaming",
    title: "Streaming services",
    options: [
      { id: "none", label: "None" },
      { id: "1-2", label: "1–2" },
      { id: "3+", label: "3+" },
    ],
  },
  {
    key: "footprint",
    title: "Roughly how many online accounts?",
    options: [
      { id: "under_20", label: "Under 20" },
      { id: "20-50", label: "20–50" },
      { id: "50-100", label: "50–100" },
      { id: "100+", label: "100+" },
    ],
  },
];
